module.exports = __webpack_public_path__ + "static/media/chef-curated-multicuisine.8834be95.jpg";